import { render, staticRenderFns } from "./OrderedListEditor.vue?vue&type=template&id=7fd72eb7"
import script from "./OrderedListEditor.vue?vue&type=script&lang=js"
export * from "./OrderedListEditor.vue?vue&type=script&lang=js"
import style0 from "./OrderedListEditor.vue?vue&type=style&index=0&id=7fd72eb7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports